import { Card, CardBody, CardFooter, Col, Row, Table } from "react-bootstrap";
import { BsDeviceSsdFill } from "react-icons/bs";
import { FaFileSignature } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import CommonUtils from "../../../../utils/common";

const SummaryMask = ({ data, setStep, hwMode }) => {

    const UTILS = new CommonUtils();

    return (
        <>
            <Row>
                <Col xl="6">
                    <Card className="shadow-lg">
                        <CardBody>
                            <p className="text-energo text-start"><b><FaLocationDot /> Adresse</b></p>
                            <Table className="equalTable" responsive="sm">
                                <tbody>
                                    <tr>
                                        <td className="text-muted"><small>Anlagenverwendung</small></td>
                                        <td>{data.x_anlagenverwendung}</td>
                                    </tr>
                                    <tr hidden={(hwMode && data.x_anlagenverwendung !== "Allgemeine Liegenschaftsteile") || (!hwMode && data.x_anlagenverwendung_detail === "" || data.x_anlagenverwendung_detail === "False")}>
                                        <td className="text-muted"><small>Spezifisch</small></td>
                                        <td>{data.x_anlagenverwendung_detail? data.x_anlagenverwendung_detail : "keine"}</td>
                                    </tr>
                                    <tr hidden={!hwMode}>
                                        <td className="text-muted"><small>Bestandseinheitennummer</small></td>
                                        <td>{data.bestand !== "" ? data.bestand : "keine"}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Land</small></td>
                                        <td>{UTILS.country_id_toStringName(data.anlgen && data.anlage.length > 0 ? data.anlagen[0].x_studio_field_e1CAm : data.country_id)}</td>
                                    </tr>
                                    <tr hidden={data.country_id !== "12"}>
                                        <td className="text-muted"><small>Bundesland</small></td>
                                        <td>{UTILS.state_id_toStringName(data.anlagen && data.anlagen.length > 0 ? data.anlagen[0].x_studio_field_GLih9[0] : data.state_id)}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>PLZ</small></td>
                                        <td>{data.anlagen && data.anlagen.length > 0 ? data.anlagen[0].x_studio_field_EIo6y : data.zip}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Ort</small></td>
                                        <td>{data.anlagen && data.anlagen.length > 0 ? data.anlagen[0].x_studio_field_dxnOV : data.city}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Straße</small></td>
                                        <td>{data.anlagen && data.anlagen.length > 0 ? data.anlagen[0].x_studio_field_mNWrb : data.street}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted"><small>Hausnummer</small></td>
                                        <td>{data.anlagen && data.anlagen.length > 0 ? data.anlagen[0].x_studio_field_uGpho : data.houseNr}</td>
                                    </tr>
                                    <tr hidden={data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile"}>
                                        <td className="text-muted"><small>Stiege</small></td>
                                        <td>{data.anlagen && data.anlagen.length > 0 ? data.anlagen[0].x_studio_field_SG6Ld : data.stiege}</td>
                                    </tr>
                                    <tr hidden={data.x_anlagenverwendung === "Allgemeine Liegenschaftsteile"}>
                                        <td className="text-muted"><small>Top</small></td>
                                        <td>{data.anlagen && data.anlagen.length > 0 ? data.anlagen[0].x_studio_field_6T9W2 : data.top}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </CardBody>
                        <CardFooter className="text-end" hidden={data.anlagen && data.anlagen.length > 0}>
                            <a 
                                onClick={e => {e.preventDefault(); setStep('address')}} 
                                href="ändern" 
                                className="link-energo"
                            >
                                Ändern
                            </a>
                        </CardFooter>
                    </Card>

                    <Card className="shadow-lg mt-3" hidden={data.anlagen && data.anlagen.length > 0}>
                        <CardBody style={data.register? {}: {opacity: 0.5}}>
                            <p className="text-energo"><b><FaFileSignature /> Anmeldedaten</b></p>
                            {data.register ?
                            <>
                                <Table className="equalTable" responsive="sm">
                                    <tbody>
                                        <tr>
                                            <td className="text-muted"><small>Anlage anmelden</small></td>
                                            <td>{UTILS.checkUncheckIcons(data.register)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Anmelden am</small></td>
                                            <td>{UTILS.dateToEuFormat(data.registerDate)}</td>
                                        </tr>
                                        {hwMode ?
                                            <>
                                                <tr>
                                                    <td className="text-muted"><small>Als Leerstand anmelden</small></td>
                                                    <td>{UTILS.checkUncheckIcons(data.leerstand)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Abrechnung über Messtechnikunternehmen</small></td>
                                                    <td>{UTILS.checkUncheckIcons(data.useMtu)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Name des Messtechnikunternehmens</small></td>
                                                    <td>{data.mtuName}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Direktverrechnung</small></td>
                                                    <td>{UTILS.checkUncheckIcons(data.mtuDirect)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Messtechnikunternehmen zahlt per Überweisung</small></td>
                                                    <td>{UTILS.checkUncheckIcons(data.mtuPaysOverTransfer)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Kontoinhaber</small></td>
                                                    <td>{data.mtuAccountOwner}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>IBAN</small></td>
                                                    <td>{data.mtuIban}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-muted"><small>Kontaktperson</small></td>
                                                    <td>{data.contact.name}</td>
                                                </tr>
                                            </>
                                            :
                                            <>
                                                <tr>
                                                    <td className="text-muted">Abweichende Kontonummer</td>
                                                    <td>{UTILS.checkUncheckIcons(data.hasDifferentAccount)}</td>
                                                </tr>
                                                {data.hasDifferentAccount === true &&
                                                    <>
                                                        <tr>
                                                            <td className="text-muted">Kontoinhaber</td>
                                                            <td>{data.kontoinhaber}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-muted">IBAN</td>
                                                            <td>{data.iban}</td>
                                                        </tr>
                                                    </>
                                                }
                                            </>
                                        }
                                    </tbody>
                                </Table>
                            </> :
                                <p className="text-center"><small>Anlage nur zum ENERGO hinzufügen.</small></p>
                            }
                        </CardBody>
                        <CardFooter className="text-end">
                            <a onClick={e => {e.preventDefault(); setStep("register")}} href="ändern" className="link-energo">Ändern</a>
                        </CardFooter>
                    </Card>
                </Col>
                {data.anlagen && data.anlagen.length > 0 ?
                    data.anlagen.map(a => (
                        <Col xs="12" md="6" xl="6">
                            <Card className="shadow-lg">
                                <CardBody>
                                    <p className="text-energo"><b><BsDeviceSsdFill /> Anlagedaten {a.x_studio_field_mWMGR}</b></p>
                                    <Table className="equalTable" responsive="sm">
                                        <tbody>
                                            <tr>
                                                <td className="text-muted"><small>Anlagennummer ENERGO</small></td>
                                                <td>{a.x_studio_field_mWMGR}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted"><small>Energieform</small></td>
                                                <td>{a.x_studio_field_3eKe0}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted"><small>Zählernummer</small></td>
                                                <td>{a.x_zaehlernummer_01}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted"><small>Zählpunktnummer</small></td>
                                                <td style={{fontSize: 11}}>{a.x_zaehlpunktnummer_01}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted"><small>Smartmeter</small></td>
                                                <td>{UTILS.checkUncheckIcons(a.x_is_smartmeter_01)}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted">Zählerstand</td>
                                                <td>{a.x_zaehlerstand_01}</td>
                                            </tr>
                                            <tr>
                                                <td className="text-muted"><small>Zweiter Zähler</small></td>
                                                <td>{UTILS.checkUncheckIcons(a.x_zaehlernummer_02 !== "" && a.x_zaehlernummer_02 !== "False")}</td>
                                            </tr>
                                            {a.x_zaehlernummer_02 !== "" && a.x_zaehlernummer_02 !== "False" &&
                                                <>
                                                    <tr>
                                                        <td className="text-muted"><small>Zählernummer 2</small></td>
                                                        <td>{a.x_zaehlernummer_02}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-muted"><small>Zählpunktnummer 2</small></td>
                                                        <td style={{fontSize: 11}}>{a.x_zaehlpunktnummer_02}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-muted"><small>Smartmeter 2</small></td>
                                                        <td>{UTILS.checkUncheckIcons(a.x_is_smartmeter_02)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-muted">Zählerstand</td>
                                                        <td>{a.x_zaehlerstand_02}</td>
                                                    </tr>
                                                </>
                                            }
                                            <tr>
                                                <td className="text-muted"><small>Bei Energielieferant Anmelden</small></td>
                                                <td>{UTILS.checkUncheckIcons(a.register)}</td>
                                            </tr>
                                            <tr hidden={!a.register || a.register === false}>
                                                <td className="text-muted"><small>Anmeldedatum</small></td>
                                                <td>{UTILS.dateToEuFormat(a.registerDate)}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    ))
                :
                    <Col xs="12" md="6" xl="6">
                        <Card className="shadow-lg">
                            <CardBody>
                                <p className="text-energo"><b><BsDeviceSsdFill /> Anlagedaten</b></p>
                                <Table className="equalTable" responsive="sm">
                                    <thead hidden={!data.secondZaehler || data.secondZaehler === false}>
                                        <tr>
                                            <td colSpan={2}>Zähler {data.x_zaehlernummer_01}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-muted"><small>Zählerstandort</small></td>
                                            <td>{!data.zaehlerLocation || data.zaehlerLocation === ""? "Nicht bekannt": data.zaehlerLocation}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Energieform</small></td>
                                            <td>{data.energyForm}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Smartmeter</small></td>
                                            <td>
                                                {UTILS.checkUncheckIcons(data.x_is_smartmeter_01)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Zählernummer</small></td>
                                            <td>{data.x_zaehlernummer_01}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Zählpunktnummer</small></td>
                                            <td>{!data.x_zaehlpunktnummer_01 || data.x_zaehlpunktnummer_01 === ""? "Nicht vorhanden": data.x_zaehlpunktnummer_01}</td>
                                        </tr>
                                        <tr hidden={!data.zaehlerstand1 || data.zaehlerstand1 === ""}>
                                            <td className="text-muted"><small>Zählerstand</small></td>
                                            <td>{data.zaehlerstand1}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                                <Table hidden={!data.secondZaehler || data.secondZaehler === false} className="equalTable mt-4">
                                    <thead>
                                        <tr>
                                            <td colSpan={2}>Zähler {data.x_zaehlernummer_02}</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-muted"><small>Zählerstandort</small></td>
                                            <td>{!data.zaehlerLocation || data.zaehlerLocation === ""? "Nicht bekannt": data.zaehlerLocation}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Energieform</small></td>
                                            <td>{data.energyForm}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Smartmeter</small></td>
                                            <td>
                                                {UTILS.checkUncheckIcons(data.x_is_smartmeter_01)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Zählernummer</small></td>
                                            <td>{data.x_zaehlernummer_02}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-muted"><small>Zählpunktnummer</small></td>
                                            <td>{!data.x_zaehlpunktnummer_02 || data.x_zaehlpunktnummer_02 === ""? "Nicht vorhanden": data.x_zaehlpunktnummer_02}</td>
                                        </tr>
                                        <tr hidden={!data.zaehlerstand2 || data.zaehlerstand2 === ""}>
                                            <td className="text-muted"><small>Zählerstand</small></td>
                                            <td>{data.zaehlerstand2}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </CardBody>
                            <CardFooter className="text-end">
                                <a onClick={e => {e.preventDefault(); setStep("anlageData")}} href="ändern" className="link-energo">Ändern</a>
                            </CardFooter>
                        </Card>
                    </Col>
                }
            </Row>
            <Row>
                <Col xs="12" md="6" xl="6">
                    
                </Col>
            </Row>
        </>
    )
}
export default SummaryMask;